// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__QttaT","input":"Checkbox_input__zSGXF","checkmark":"Checkbox_checkmark__VizU3","label":"Checkbox_label__nVYgX"};